import warningIcon from "../../../assets/warning.svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorMessage = () => /*#__PURE__*/_jsxs("div", {
  className: "w-full flex flex-col rounded-lg p-2 text-left bg-[#FFD9CD]",
  children: [/*#__PURE__*/_jsxs("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/_jsx("img", {
      src: warningIcon,
      alt: "errorIcon",
      className: "h-4 w-4 mr-2"
    }), /*#__PURE__*/_jsx("div", {
      className: "text-md font-modern-era-medium",
      children: "Error"
    })]
  }), /*#__PURE__*/_jsx("div", {
    className: "text-sm font-modern-era-medium",
    children: "Transaction failed. Please try again."
  })]
});